var current_font = "Neonscript";
var current_font_type = "normal";
  
var placeholder = 'HIER TEXT EINGEBEN \n Für Zeilenumbruch ENTER drücken';
  
  
  
//   jQuery(document).ready(function(){
    
    
    jQuery("#leftInnerPanel").click(function(){
    var body = document.body; // Safari
var html = document.documentElement; // Chrome, Firefox, IE and Opera places the overflow at the <html> level, unless else is specified. Therefore, we use the documentElement property for these browsers

//body.scrollTop = 0;
      
// Where el is the DOM element you'd like to test for visibility
function isHidden(el) {
    var style = window.getComputedStyle(el);
    return (style.display === 'none')
}
 //el = document.getElementById("shopify-section-header")     
 var el = document.querySelector("#shopify-section-header .nav-bar");
      if(isHidden(el)){
html.scrollTop = 120;
      
      }
      else{
      html.scrollTop = 110;
                
      }
    });
    
    
    
   $("#textPlace").textareaCounter({
		txtElem:'textPlace',
        charElem:'charCount',
        lineElem:'lineCount',
        progElem:'progress-percent',
        progPerc:'progPercentage',
        txtCount:'100',
        lineCount:'30'
        
	});

    
    

$('#textPlace').val(placeholder);


$('#textPlace').focus(function(){
    if($(this).val() === placeholder){
        $(this).val('');
    }
});

$('#textPlace').blur(function(){
    if($(this).val() ===''){
        $(this).val(placeholder);
    }    
});
    
    
    
    
  function calculatorload(){
    if(jQuery("#calculator").length<1)
    {	
      setTimeout(calculatorload,50);
		//();
    }
    else{
            jQuery("body.productPage").removeClass("productPage");
    	   var characterlength = jQuery(".textContainer").html().replace(/\n/g,'').replace(/ /g,'').replace(/&amp;/g, '&').length;
 
 
    	changeVariantSize(characterlength);
    }
  }
  setTimeout(calculatorload,0);
  
//   });
  
  
  jQuery(".on-off-btn").click(function(){
    if($(this).hasClass("on")){
    	$(this).removeClass("on");
      $(".gvsmain").removeClass("shadowoff");
       
    }
    else{
    	$(this).addClass("on");
        $(".gvsmain").addClass("shadowoff");
    }
     totalPrice();
  });
  
  
  jQuery("button[id='add_to_cart']").click(function(e){
    console.log("test");
    if(jQuery(this).hasClass('disabled') != true){
  	    jQuery(".product-form button[data-action='add-to-cart']").trigger("click");
    }
    else{
     
      if((jQuery(".errorMSg").html()) !=""){
        e.preventDefault();
    	alert('Zu viele Buchstaben in einer Zeile für die gewählte Größe. Bitte wählen Sie eine andere Größe oder reduzieren Sie die Anzahl der Buchstaben pro Zeile.');
      }
    }
  });
  
  
  function inchToCm(thisVal){
	return Math.ceil(thisVal*2.54); 
  }
  
   
  function changeVariantSize(charlength){

    	charlength = charlength <1 ? 1 : charlength;
    
           var reqData = lightDetail[current_font_type][(charlength-1)];

      // var reqData = lightDetail[(charlength-1)];
    jQuery("#size_table .zeroPrice").removeClass("zeroPrice");
    if(reqData.small.price<1){ jQuery("#size_table [data-size='s']").addClass("zeroPrice"); }
     if(reqData.medium.price<1){ jQuery("#size_table [data-size='m']").addClass("zeroPrice"); }
     if(reqData.large.price<1){ jQuery("#size_table [data-size='l']").addClass("zeroPrice"); }
     if(reqData['x large'].price<1){ jQuery("#size_table [data-size='xl']").addClass("zeroPrice"); }
     if(reqData['xx large'].price<1){ jQuery("#size_table [data-size='xxl']").addClass("zeroPrice"); }
     if(reqData.supersized.price<1){ jQuery("#size_table [data-size='su']").addClass("zeroPrice"); }
    		
    
    var newString = jQuery("#textPlace").val().trim().replace(/\n\n/g,'\n');
      var allLines = newString.split("\n");
    var LinesCount = allLines.length - 1;
    
    
            jQuery("#size_table [data-size='s'] .vprice").html(Shopify.formatMoney(exchangeVal*((reqData.small.price)+(LinesCount*30)), window.theme.moneyFormat));
    		jQuery("#size_table [data-size='s'] [name='vprice']").val(exchangeVal*((reqData.small.price)+(LinesCount*30))/100);
    		jQuery("#size_table [data-size='s'] .vlength").html('Breite: '+inchToCm(reqData.small.length)+'cm');
    		jQuery("#size_table [data-size='s']").attr("wasserfest",exchangeVal*reqData.small.wasserfest/100);
    
    
            jQuery("#size_table [data-size='m'] .vprice").html(Shopify.formatMoney(exchangeVal*((reqData.medium.price)+(LinesCount*40)), window.theme.moneyFormat));
    		jQuery("#size_table [data-size='m'] [name='vprice']").val(exchangeVal*((reqData.medium.price)+(LinesCount*40))/100);
            jQuery("#size_table [data-size='m'] .vlength").html('Breite: '+inchToCm(reqData.medium.length)+'cm');
        	jQuery("#size_table [data-size='m']").attr("wasserfest",exchangeVal*reqData.medium.wasserfest/100);
    
            jQuery("#size_table [data-size='l'] .vprice").html(Shopify.formatMoney(exchangeVal*((reqData.large.price)+(LinesCount*50)), window.theme.moneyFormat));
    		jQuery("#size_table [data-size='l'] [name='vprice']").val(exchangeVal*((reqData.large.price)+(LinesCount*50))/100);
            jQuery("#size_table [data-size='l'] .vlength").html('Breite: '+inchToCm(reqData.large.length)+'cm');
        	jQuery("#size_table [data-size='l']").attr("wasserfest",exchangeVal*reqData.large.wasserfest/100);
    
            jQuery("#size_table [data-size='xl'] .vprice").html(Shopify.formatMoney(exchangeVal*((reqData['x large'].price)+(LinesCount*60)), window.theme.moneyFormat));
    		jQuery("#size_table [data-size='xl'] [name='vprice']").val(exchangeVal*((reqData['x large'].price)+(LinesCount*60))/100);
            jQuery("#size_table [data-size='xl'] .vlength").html('Breite: '+inchToCm(reqData['x large'].length)+'cm');
        	jQuery("#size_table [data-size='xl']").attr("wasserfest",exchangeVal*reqData['x large'].wasserfest/100);    
    
            jQuery("#size_table [data-size='xxl'] .vprice").html(Shopify.formatMoney(exchangeVal*((reqData['xx large'].price)+(LinesCount*60)), window.theme.moneyFormat));
    		jQuery("#size_table [data-size='xxl'] [name='vprice']").val(exchangeVal*((reqData['xx large'].price)+(LinesCount*60))/100);
            jQuery("#size_table [data-size='xxl'] .vlength").html('Breite: '+inchToCm(reqData['xx large'].length)+'cm');
        	jQuery("#size_table [data-size='xxl']").attr("wasserfest",exchangeVal*reqData['xx large'].wasserfest/100);    
    
            jQuery("#size_table [data-size='su'] .vprice").html(Shopify.formatMoney(exchangeVal*((reqData.supersized.price)+(LinesCount*60)), window.theme.moneyFormat));
    		jQuery("#size_table [data-size='su'] [name='vprice']").val(exchangeVal*((reqData.supersized.price)+(LinesCount*60))/100);
            jQuery("#size_table [data-size='su'] .vlength").html('Breite: '+inchToCm(reqData.supersized.length)+'cm');
        	jQuery("#size_table [data-size='su']").attr("wasserfest",exchangeVal*reqData.supersized.wasserfest/100);
    
    
    
    
    //////////////////////////// height changes
    
    
    	var lineslength = jQuery("#lineCount").html();
         lineslength = parseInt(lineslength);
       var reqData = heightDetail[current_font][(lineslength-1)];
            jQuery("#size_table [data-size='s'] .vheight").html('Höhe: '+reqData.small.height+'cm');
            jQuery("#size_table [data-size='m'] .vheight").html('Höhe: '+reqData.medium.height+'cm');
    
            jQuery("#size_table [data-size='l'] .vheight").html('Höhe: '+reqData.large.height+'cm');
    
            jQuery("#size_table [data-size='xl'] .vheight").html('Höhe: '+reqData['x large'].height+'cm');
    
            jQuery("#size_table [data-size='xxl'] .vheight").html('Höhe: '+reqData['xx large'].height+'cm');
    
            jQuery("#size_table [data-size='su'] .vheight").html('Höhe: '+reqData.supersized.height+'cm');
    
    
     var waterProofPrice0 = jQuery(".size-box.active").attr("wasserfest");
    jQuery("input#waterProofYes").val(exchangeVal*(waterProofPrice0)/100);
    jQuery(".waterProof .waterProofYes").html("+ "+Shopify.formatMoney(exchangeVal*waterProofPrice0, window.theme.moneyFormat));
    
    
    
    
    

			totalPrice();
    //gg
       	
  }
  
   function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
   
  
  function totalPrice(){
   

    
    var currentHeight = jQuery(".size-box.active .vheight").html();
    currentHeight = currentHeight.replace("Höhe: ","");
    jQuery('[name="properties[Höhe]"]').val(currentHeight);

    var currentColor = jQuery(".clr-btn.active").attr("color_name");
	jQuery('[name="properties[Farbe]"]').val(currentColor);    
    var currentFont = jQuery(".font_li>li.active").attr("data_id");
	jQuery('[name="properties[Schriftart]"]').val(currentFont);    
    var currentUsage = jQuery(".waterProof .custom-radio.selected label").text();
	jQuery('[name="properties[Nutzung]"]').val(currentUsage);    
    var currentPlug = jQuery("#ele_plug").html();
	jQuery('[name="properties[Stromstecker]"]').val(currentPlug);   
   
    var currentHindergrund = jQuery("#hintergrund").html();
	jQuery('[name="properties[Hintergrund]"]').val(currentHindergrund); 

    var currentText = jQuery(".textContainer").html();
    var currentText2 = jQuery(".textContainer").html();
    currentText2 = currentText2.replace(/\n/g, "<br>");
    jQuery('[name="properties[Text]"]').val(currentText2);
    currentText = currentText.replace(/\n/g, "~~n");
	//console.log("here is text="+currentText);
    
    
    
  //  var currentStyle = jQuery(".textContainer").attr("style");
    var currentStyle = "font-size:"+jQuery(".textContainer").css("font-size")+";color:"+jQuery(".textContainer").css("color")+";font-family:"+jQuery(".textContainer").css("font-family")+"; text-shadow:"+jQuery(".textContainer").css("text-shadow");
    	jQuery('[name="properties[Style]"]').val(currentStyle);
    currentStyle = currentStyle.replace(/\./g,"^");
   var imgurl = "https://www.neontrip.de/products/custom-neon/imgurl="+encodeURI(currentText)+"="+encodeURI(currentStyle);
    //console.log(imgurl);


    jQuery('[name="properties[Image Url]"]').val(imgurl);
    
    
      var currentTextShadow = "JA";
    if(jQuery(".gvsmain.shadowoff").length>0){
    	 currentTextShadow = "NEIN";
    }
// 	jQuery('[name="properties[Text Shadow]"]').val(currentTextShadow); 


    
    
    
   // debugger;
  	 var sizePrice = jQuery("#size_table [name='vprice']:checked").val();
     //debugger;
   	var waterProof = jQuery(".waterProof [name='waterProof']:checked").val();
    
    var back_board = jQuery("[name='back_board']:checked").val();
    var HINTERGRUND  = jQuery("[name='HINTERGRUND']:checked").val();
   // var designproof  = jQuery("[name='designproof']:checked").val();
    
 	 //var currentDesignApproved = ($('input[name="designproof"]:checked').val()) != 0 ? "JA" : "NEIN" ;
	//jQuery('[name="properties[Proof of Design]"]').val(currentDesignApproved);    
    
    
    
    
    var freeRemote = ($('input[name="Sonderangebot"]:checked').length) > 0 ? "JA" : "NEIN" ;
    jQuery('[name="properties[Sonderangebot]"]').val(freeRemote);    
    
    
    var back_board_html = jQuery("[name='back_board']:checked").parents(".dropdown-item").find("a").text();
    
    back_board_html = back_board_html.trim();
    
    
    

    var currentLength = jQuery(".size-box.active .s_size2 .vlength").html();
    currentLength = currentLength.replace("Breite: ","");
    
    jQuery('[name="properties[Breite]"]').val(currentLength);
    
    currentLength = currentLength.replace('"','');
    currentLength = parseInt(currentLength);

    if(currentLength>151){
    	jQuery(".length_warning_msg").addClass("active");
    }
    else{
        	jQuery(".length_warning_msg.active").removeClass("active");
    }

    if(back_board==0){jQuery("#board_price").html(back_board_html);}else{    back_board_html = back_board_html.replace("+"," ( +");
jQuery("#board_price").html(back_board_html+")");}
    	jQuery('[name="properties[Hintergrund Zuschnitt]"]').val(jQuery("#board_price").text());

    
    var wall_mounting = 0;
    
    wall_mounting = ($('input[name="wall_mounting"]:checked').length) > 0 ? $('input[name="wall_mounting"]:checked').val() : 0 ;
    
    var currentWallMount = ($('input[name="wall_mounting"]:checked').length) > 0 ? "JA" : "NEIN" ;
	jQuery('[name="properties[Klebeset]"]').val(currentWallMount); 
    
        var sign_hanging = 0;
    
    sign_hanging = ($('input[name="sign_hanging"]:checked').length) > 0 ? $('input[name="sign_hanging"]:checked').val() : 0 ;
    var currentSignHang = ($('input[name="sign_hanging"]:checked').length) > 0 ? "JA" : "NEIN" ;
	jQuery('[name="properties[Hängeset]"]').val(currentSignHang); 
    
        var express_produktion = 0;
    
    express_produktion = ($('input[name="express_produktion"]:checked').length) > 0 ? $('input[name="express_produktion"]:checked').val() : 0 ;
    var currentExpressProduktion  = ($('input[name="express_produktion"]:checked').length) > 0 ? "JA" : "NEIN" ;
	jQuery('[name="properties[Express Produktion]"]').val(currentExpressProduktion); 
    
    sizePrice = sizePrice.replace(",","");
    
var totalPrice = parseFloat(sizePrice) + parseFloat(waterProof) + parseFloat(back_board) + parseFloat(wall_mounting) + parseFloat(sign_hanging) + parseFloat(express_produktion) + parseFloat(HINTERGRUND);// + parseFloat(designproof);
    

    
    if(totalPrice<10){ jQuery(".gvsmain [id=add_to_cart]").addClass("disabled");}
    else if(totalPrice>=10 && jQuery(".errorMSg").html()==""){jQuery(".gvsmain [id=add_to_cart]").removeClass("disabled");}

    if(jQuery("#size_table .zeroPrice.active .noprice:visible").length>0){jQuery(".gvsmain [id=add_to_cart]").addClass("disabled");}
    
   
    	var correcttotalprice  = Shopify.formatMoney(totalPrice*100, window.theme.moneyFormat)
   
   
         jQuery(".total_sel_price").html(correcttotalprice);
    

  
   
    //console.log(100/exchangeVal*totalPrice);
    
    jQuery("#calculator [name='properties[Price]']").val(100/exchangeVal*totalPrice);
     //   jQuery("#calculator [name='properties[Price]']").focus();
    jQuery("#calculator [name='properties[Price]']").change();
     
    jQuery("#calculator [name='properties[Price]']").trigger("change");
    

   
  
  }
// jQuery('[name="designproof"]').change(function(){
// 	totalPrice();
// });

  
jQuery("#size_table .size-box [type='radio']").click(function(e){
	e.stopPropagation();
   var THIS = jQuery("#textPlace");
    
      jQuery(".gvsmain [id=add_to_cart]").removeClass("disabled");
      jQuery(".errorMSg").html("");

    if(THIS.val() !== "" && THIS.val() != placeholder ){
          var characterSize = THIS.val().trim().replace(/ /g,'').replace(/\n/g,'').replace(/&amp;/g, '&').length;
    
  
      var a = THIS.val().trim();

       
var position =jQuery("#size_table .size-box.active").attr("lineLenth");
     
      
var allLinesData = a.split("\n");
var countLines = allLinesData.length;
var output =a; var lengthError=false;
      for(var jo=0;jo<countLines;jo++){
       
        if(allLinesData[jo].length>position){
        	lengthError=true;
        }
    } 
      console.log(characterSize);
      if(characterSize>40){jQuery(".errorMSg").html("Maximal 40 Buchstaben erlaubt. Für mehr Buchstaben bitte Support anschreiben"); jQuery(".gvsmain [id=add_to_cart]").addClass("disabled");}
        else if(lengthError){
        	jQuery(".errorMSg").html("Maximal "+position+" Buchstaben pro Zeile für diese Größe."); jQuery(".gvsmain [id=add_to_cart]").addClass("disabled");
        }
      
    }
  
});

  jQuery("#size_table .size-box").click(function(e){
      //  e.stopPropagation();
    
    
    
    
    
    jQuery("#size_table .size-box.active").removeClass("active");
   // jQuery(this).find("[name='vprice']").checked = true;

    
    jQuery(this).addClass("active");
    
    
   
    jQuery(this).find("[name='vprice']").trigger("click");
    var boardprices = jQuery(this).attr("board_price");
    boardprices = JSON.parse(boardprices)
    
    //exchangeVal*reqData.small.price/100 Shopify.formatMoney(parseFloat(back_board)*100, window.theme.moneyFormat)boardprices[0]
    
    	jQuery(".paidboard1").find("input[name='back_board']").val(exchangeVal*(boardprices[0])/100);
        jQuery(".paidboard2").find("input[name='back_board']").val(exchangeVal*(boardprices[1])/100);
        jQuery(".paidboard3").find("input[name='back_board']").val(exchangeVal*(boardprices[2])/100);
    
    	jQuery(".paidboard1").find(".board_txt").html(Shopify.formatMoney(exchangeVal*boardprices[0], window.theme.moneyFormat));
    	jQuery(".paidboard2").find(".board_txt").html(Shopify.formatMoney(exchangeVal*boardprices[1], window.theme.moneyFormat));
    	jQuery(".paidboard3").find(".board_txt").html(Shopify.formatMoney(exchangeVal*boardprices[2], window.theme.moneyFormat));
//    debugger;
        var waterProofPrice = jQuery(this).attr("wasserfest");
    jQuery("input#waterProofYes").val(exchangeVal*(waterProofPrice)/100);
    jQuery(".waterProof .waterProofYes").html("+ "+Shopify.formatMoney(exchangeVal*waterProofPrice, window.theme.moneyFormat));
    
    jQuery('[name="properties[Größe]"]').val(jQuery(this).find("strong").html());
  	
    totalPrice();
  });
  
  jQuery(".waterProof .custom-control").click(function(e){
  	jQuery(".waterProof .custom-control.selected").removeClass("selected");
     e.stopPropagation();
    jQuery(this).find("[name='waterProof']").trigger("click");
    jQuery(this).addClass("selected");
    totalPrice();
  });
  
  jQuery(".dropdown-item").click(function(e){
     e.stopPropagation();
    if(jQuery(this).hasClass("HINTERGRUND_ZUSCHNITT")){
      var thisorder = jQuery(this).find(".board-box").attr("data-type");
      //debugger;
      jQuery("#board_img").attr("src","https://cdn.shopify.com/s/files/1/0534/7819/5350/files/board_"+thisorder+".png")
    }
    
     if (!($(e.target).is('input'))){
    jQuery(this).find("input").trigger("click");
	
    var selectOption = jQuery(this).find(".board_txt").html();
//    debugger;
    jQuery(this).parents(".dropdown,.dropdown-b").find(".dropdownPrice").html(selectOption);
           jQuery(this).parents(".dropdown,.dropdown-b").find(".dropdown-toggle").trigger("click");
    		totalPrice();

     }
  });
  
  jQuery(".gvsmain [type='checkbox']").click(function(){
    totalPrice();
  });
  
  
  
  jQuery(".fontsize_range input").on('input', function() {
    jQuery(".fontsize_range:not(.changed)").addClass("changed");
    var currentrange = jQuery(this).val();
  	jQuery(".forDesktop .textContainer,.forMobile .textContainer").css("font-size",currentrange+"px");
  
  });
  
  
  var textPlace = jQuery("#textPlace").val();

	var precharacterlength = jQuery(".forDesktop .textContainer").width();
  	var mobprecharacterlength = jQuery(".forMobile .textContainer").width();
  
  
  jQuery("#textPlace").keyup(function(event){
//    	var characterlength = jQuery(this).val().length;
    	
    if($(this).val() === placeholder){
        $(this).val('');
    }
    if(jQuery(this).val() !== "" ){
          var characterSize = $(this).val().replace(/ /g,'').replace(/\n/g,'').replace(/&amp;/g, '&').length;
          var characterSize_a =  characterSize;


      var a = jQuery(this).val();
var b = "\n";
var lastNewLine = a.lastIndexOf("\n");
      if(lastNewLine!=-1){
      	characterSize = characterSize - (lastNewLine);
      }  
      
      //  console.log("characterSize="+characterSize);
      // console.log("previous postion is="+lastNewLine);
var position =jQuery("#size_table .size-box.active").attr("lineLenth");
      //console.log("current postion is="+position);
      
      
      
//var output =      a.substring(0, position) + "\n" + a.substring(position, a.length);
      
var output =     a;      
      if(event.keyCode!=8 && characterSize>0 && characterSize%position==0){
      
        output = a+"\n";      
      }
      var newString = output.replace(/\n\n/g,'\n');
      var Lines = newString.split("\n");
      jQuery(".gvsmain [id=add_to_cart]").removeClass("disabled");
      jQuery(".errorMSg").html("");
      for(var jp=0;jp<Lines.length;jp++){
       
          var thislinelength = Lines[jp].length;
        var spaceCount = (Lines[jp].split(" ").length - 1);
          var newLineCount = (Lines[jp].split("\n").length - 1);
			
  var actualLenth = thislinelength-parseInt(spaceCount)+parseInt(newLineCount); 
        if(characterSize_a>40){jQuery(".errorMSg").html("Maximal 40 Buchstaben erlaubt. Für mehr Buchstaben bitte Support anschreiben"); jQuery(".gvsmain [id=add_to_cart]").addClass("disabled");}
        else if(actualLenth>position){
        	jQuery(".errorMSg").html("Maximal "+position+" Buchstaben pro Zeile für diese Größe."); jQuery(".gvsmain [id=add_to_cart]").addClass("disabled");
        } 
        

		
      }
      
      
      
//console.log(output);
      $(this).val(output);
     // if(characterSize%10==0){
      jQuery(".textContainer").html(output);

      //}	
      
  		//jQuery(".textContainer").html(jQuery(this).val());
    }  
    var characterlength = jQuery(".textContainer").html().replace(/\n/g,'').replace(/ /g,'').replace(/&amp;/g, '&').length;
 
 
    	changeVariantSize(characterlength);
  });
  
  jQuery("#textPlace").bind('paste', function(event) {
    var THIS = $(this);
    setTimeout(function(){
      jQuery(".gvsmain [id=add_to_cart]").removeClass("disabled");
      jQuery(".errorMSg").html("");
 if(THIS.val() === placeholder){
        THIS.val('');
    }
    if(THIS.val() !== "" ){
          var characterSize = THIS.val().replace(/ /g,'').replace(/\n/g,'').replace(/&amp;/g, '&').length;
    
  
      var a = THIS.val();

       
var position =jQuery("#size_table .size-box.active").attr("lineLenth");
      console.log("pasted");
      
       

      var b = "\n";
      var lastNewLine = a.lastIndexOf("\n");

      
      


var output =a.replace(/\n/g,' ').replace(/  /g,' '); 
      for(var jo=position;jo<=characterSize;){
       
          var newsubstring = output.substring(0,jo);
       
          var spaceCount = (newsubstring.split(" ").length - 1);
          var newLineCount = (newsubstring.split("\n").length - 1);
			
  var newjo = jo+parseInt(spaceCount)+parseInt(newLineCount); 
 output = [output.slice(0, newjo), b, output.slice(newjo)].join('');


        
       jo=position+newjo;
      }
      
      
       if(characterSize>30){jQuery(".errorMSg").html("Only 30 characters allowed.");
                           jQuery(".gvsmain [id=add_to_cart]").addClass("disabled");
                           }
        
      
 THIS.val(output);
     // if(characterSize%10==0){
      jQuery(".textContainer").html(output);
    }  
    var characterlength = jQuery(".textContainer").html().replace(/\n/g,'').replace(/ /g,'').replace(/&amp;/g, '&').length;
 
 
    	changeVariantSize(characterlength);
    },500);
});
  
  jQuery("ul.font_li>li").click(function(){
   var thisfont = jQuery(this).attr("data_id");
   var font_type = jQuery(this).attr("f_type");
   var thisfontSizeDesktop = jQuery(this).attr("data-desk");
   var thisfontSizeMobile = jQuery(this).attr("data-mob");
      jQuery("ul.font_li>li.active").removeClass("active");
    jQuery(this).addClass("active");
    if(!(jQuery(".fontsize_range").hasClass("changed"))){
      jQuery(".forDesktop .textContainer").css("font-size",thisfontSizeDesktop+"px");
      jQuery(".forMobile .textContainer").css("font-size",thisfontSizeMobile+"px");
    }
    jQuery(".textContainer").css("font-family",thisfont);
    current_font = thisfont;
    current_font_type = font_type;
    jQuery("#textPlace").trigger("keyup");
    
  });
  jQuery("ul#color_table>li").click(function(){
    jQuery("ul#color_table>li").find(".clr-btn.active").removeClass("active");
    jQuery(this).find(".clr-btn").addClass("active");
   var thiscolor = jQuery(this).find(".clr-btn").attr("data_color");
   var thiscolorname = jQuery(this).find(".clr-btn").attr("color_name");
    jQuery(this).find(".clr-btn").css("box-shadow",thiscolor+" 0px 0px 10px");
    
    var this_shadow = "rgb(255 255 255) 0px 0px 5px, "+thiscolor+" 0px 0px 10px, "+thiscolor+" 0px 0px 20px, "+thiscolor+" 0px 0px 30px, "+thiscolor+" 0px 0px 40px, "+thiscolor+" 0px 0px 55px, "+thiscolor+" 0px 0px 75px";
    
    jQuery(".textContainer").css("text-shadow",this_shadow);
    jQuery(".textContainer").attr("id",thiscolorname);
    
    var thiscolortext = jQuery(this).find(".clr-btn").attr("color_text");
    jQuery(".color_desc .cdesc").html(thiscolortext);
    var reqcolorname = thiscolorname.replace("_"," ");
    var colorimgname = thiscolorname.replace("_","");
    jQuery(".color_desc .lightboxHandle").html("<br>Hier klicken für mehr Beispielbilder von "+reqcolorname);
    jQuery(".color_desc .cimg").css("background-image","url(https://cdn.shopify.com/s/files/1/0534/7819/5350/files/"+colorimgname+".jpg)");
    jQuery("#item .popimg").attr("src","https://cdn.shopify.com/s/files/1/0534/7819/5350/files/big_"+colorimgname+".jpg")
    
    totalPrice();
   
  });





 $('.slider-for').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  fade: true,
  asNavFor: '.slider-nav'
});
$('.slider-nav').slick({
  slidesToShow: 5,
  slidesToScroll: 1,
  asNavFor: '.slider-for',
  dots: false,
  centerMode: true,
  focusOnSelect: true
});
  
   $('.slider-for2').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  fade: true,
  asNavFor: '.slider-nav2'
});
$('.slider-nav2').slick({
  slidesToShow: 5,
  slidesToScroll: 1,
  asNavFor: '.slider-for2',
  dots: false,
  centerMode: true,
  focusOnSelect: true
});